import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 19 36",
  "content": "<symbol viewBox=\"0 0 19 36\" xmlns=\"http://www.w3.org/2000/svg\" id=\"facebook\">\n<path d=\"M14.8292 6.31146H18.0244V0.746458C17.4732 0.670625 15.5773 0.5 13.3694 0.5C8.76253 0.5 5.6067 3.39771 5.6067 8.72354V13.625H0.522949V19.8463H5.6067V35.5H11.8396V19.8477H16.7177L17.4921 13.6265H11.8382V9.34042C11.8396 7.54229 12.3238 6.31146 14.8292 6.31146V6.31146Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol